import "../../public/static/styles/ag-grid-overrides.scss";
import "../../public/static/styles/ag-grid-overrides.css";
import React from "react";
import { Typography } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import HeaderComponent from "./HeaderComponent";
import { BooleanCellRenderer, DefaultCellFormatter, FloatCellFormatter, ForeignKeyCellRenderer } from "./CellFormatter";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { INDEX_COLUMN } from "../../Constants";
const Styled_Overlay = styled("div")(({ theme }) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
}));
const RELOAD_THRESHOLD = 0.9;
const Table = (props) => {
    const [t, i18n] = useTranslation();
    const onSelectionChanged = (event) => {
        if (props.onSelectionChanged) {
            let data = event.api.getSelectedNodes().map((rowNode) => rowNode.data);
            if (props.isMultiRowSelection) {
                props.onSelectionChanged(data);
            }
            else {
                props.onSelectionChanged(data[0]);
            }
        }
    };
    const onGridReady = (params) => {
        if (props.onGridReady) {
            props.onGridReady(params);
        }
        if (props.sizeColumnsToFit) {
            params.api.sizeColumnsToFit();
            params.api.resetRowHeights();
        }
        const sortModel = props.initSortModel;
        if (sortModel) {
            const curretSortModel = params.columnApi.getColumnState();
            const mergeSortModel = curretSortModel.map((o1) => sortModel.find((o2) => o2.colId === o1.colId) || o1);
            params.columnApi.applyColumnState({ state: mergeSortModel });
        }
    };
    const onRowEditingStopped = (event) => {
        if (props.onRowUpdated) {
            props.onRowUpdated(event);
        }
    };
    const renderOverlay = () => {
        let overlayText = "";
        if (props.overlayText) {
            overlayText = props.overlayText;
        }
        else if (!props.data) {
            overlayText = t("translations:info no rows");
        }
        if (overlayText) {
            return (React.createElement(Styled_Overlay, null,
                React.createElement(Typography, { variant: "body1" }, overlayText)));
        }
        return React.createElement(React.Fragment, null);
    };
    let frameworkComponents = props.frameworkComponents ? props.frameworkComponents : {};
    frameworkComponents["booleanCellRenderer"] = BooleanCellRenderer;
    frameworkComponents["defaultCellRenderer"] = DefaultCellFormatter;
    frameworkComponents["floatCellRenderer"] = FloatCellFormatter;
    frameworkComponents["foreignKeyCellRenderer"] = ForeignKeyCellRenderer;
    frameworkComponents["agColumnHeader"] = HeaderComponent;
    return (React.createElement("div", { style: { position: "relative" } },
        React.createElement("div", { className: "ag-theme-balham-zeb", style: { height: "calc(100vh - 29rem)", width: "100%" } },
            React.createElement(AgGridReact, { defaultColDef: {
                    resizable: true,
                    sortable: true,
                    filter: true,
                }, suppressFieldDotNotation: true, context: props.context ? props.context : {}, rowSelection: props.isMultiRowSelection ? "multiple" : "single", columnDefs: props.columns, rowData: props.data, onSelectionChanged: onSelectionChanged, components: frameworkComponents, enableCellTextSelection: true, suppressNoRowsOverlay: true, onGridReady: onGridReady, isExternalFilterPresent: props.isExternalFilterPresent, doesExternalFilterPass: props.doesExternalFilterPass, onCellValueChanged: onRowEditingStopped, onViewportChanged: (event) => {
                    if (props.data && props.data.length > 0) {
                        let pos = event.lastRow / props.data.length;
                        if (pos > RELOAD_THRESHOLD) {
                            props.requestData();
                        }
                    }
                }, onSortChanged: props.requestData, getRowId: (params) => params.data[INDEX_COLUMN] }),
            renderOverlay())));
};
export default Table;
